import { FunctionComponent, useEffect, useRef, useState } from "react";
import "./ExamDate.scss";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import ButtonField from "../../Components/Button/ButtonField";
import { Columns } from "../../Components/Table/ITable";
import {
  GridRenderCellParams,
  GridValueFormatterParams,
} from "@mui/x-data-grid";
import { IExamdate } from "./IExamDate";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import Dialog from "../../Components/Dialog/Dialog";
import ExamdateForm from "./ExamDateForm";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import TableSearch from "../../Components/Table/components/TableSearch";
import { ReactComponent as Delete } from "../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../Assets/Images/edit.svg";
import { IDeleteDialog } from "../../Components/DeleteDialog/IDeleteDialog";
import IconButtonField from "../../Components/Button/IconButtonField";
import { SvgIcon } from "@mui/material";
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import { ReactComponent as RefreshButton } from "../../Assets/Images/RefreshButton.svg";
import { listExamdate } from "../../Redux/Slices/Examdate/ListExamdateSlice";
import { clearAddExamdateResponse } from "../../Redux/Slices/Examdate/AddExamdateSlice";
import {
  clearDeleteExamdateResponse,
  deleteExamdate,
} from "../../Redux/Slices/Examdate/DeleteExamdateSlice";
import { clearEditExamdateResponse } from "../../Redux/Slices/Examdate/EditExamdateSlice";
import { listSideMenuPermission } from "../../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";
import { listYearlevel_map } from "../../Redux/Slices/Yearlevel_map/ListYearlevel_mapSlice";

interface ExamdateProps { }

const Examdate: FunctionComponent<ExamdateProps> = () => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [deleteDialogData, setDeleteData] = useState<IDeleteDialog>({});
  const [initialValues, setInitialValues] = useState<IExamdate | {}>({
    status: true,
  });
  const dispatch = useAppDispatch();
  const { data: listExamdates } = useAppSelector(
    (state) => state.ListExamdateSlice
  );
  const { data: addExamdate } = useAppSelector(
    (state) => state.AddExamdateSlice
  );
  const { data: EditExamdate } = useAppSelector(
    (state) => state.EditExamdateSlice
  );
  const { data: deleteExamdates } = useAppSelector(
    (state) => state.DeleteExamdate
  );

  const permissions = useAppSelector((state) => state.PermissionsToPage);
  const finaldata = { permissions };

  const formRef = useRef<HTMLFormElement>(null);
  const columns: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      width: 90,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "name",
      renderHeader: () => <b>Country Name</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "exam_date",
      headerName: "Exam Date",
      renderHeader: () => <b>Exam Date</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
      renderCell: (params) => {
        const date = new Date(params.value);
        const formatted = date.toLocaleDateString("en-GB"); // Outputs DD/MM/YYYY
        // Replace slashes with dashes
        return formatted.replace(/\//g, "-");
      },
    },
    {
      field: "region",
      renderHeader: () => <b>Region</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
      renderCell: (params: GridRenderCellParams<IExamdate>) => {
        const region = params.row.region;
        return region ? `${region.state_name}, ${region.country}` : "-";
      },
    },
    {
      field: "year_group",
      renderHeader: () => <b>Year Group</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
      renderCell: (params: GridRenderCellParams<IExamdate>) => {
        const yearGroup = params.row.year_group;
        return yearGroup ? yearGroup.year_group : "-";
      },
    },
    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
      cellClassName: (params) =>
        `activename ${params.row.status ? "active" : "inactive"}`,

      valueFormatter: (params) =>
        params.value === true ? "Active" : "Inactive",
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      renderCell: (params: GridRenderCellParams<IExamdate>) => {
        return (
          <>
            <IconButtonField
              disabled={finaldata?.permissions?.edit === false}
              onClick={() => {
                setInitialValues({ ...params.row, id: params.id as number });
                setIsEdit(true);
                setDialogOpen(true);
              }}
            >
              <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
            </IconButtonField>
            <IconButtonField
              disabled={finaldata?.permissions?.delete === false}
              onClick={() => {
                setDeleteData({ id: params.id, name: "" });
                setDeleteDialogOpen(true);
              }}
            >
              <SvgIcon component={Delete} inheritViewBox />
            </IconButtonField>
          </>
        );
      },
    },
  ];

  const Examdate = Array.isArray(listExamdates?.data)
    ? listExamdates?.data.map((user, index) => ({ ...user, index: index + 1 }))
    : [];

  useEffect(() => {
    dispatch(listYearlevel_map());
    dispatch(listExamdate());
    // dispatch(listSideMenuPermission());
  }, [addExamdate, EditExamdate, deleteExamdates, dispatch]);
  useEffect(() => {
    return () => {
      dispatch(clearAddExamdateResponse());
      dispatch(clearEditExamdateResponse());
      dispatch(clearDeleteExamdateResponse());
    };
  }, [dispatch]);
  return (
    <>
      <Table rows={Examdate ?? []} columns={columns} exportFileName="Exam_Dates">
        <CustomToolbar>
          <h6></h6>
          <TableSearch />
          <ButtonField
            className="tabel_add_new_button"
            onClick={() => {
              setInitialValues({ status: true });
              setIsEdit(false);
              setDialogOpen(true);
            }}
            toolTip="Add new"
            disabled={finaldata?.permissions?.add === false}
          >
            Add new
          </ButtonField>
          <IconButtonField
            className="refresh_btn"
            toolTip="Refresh"
            onClick={() => dispatch(listExamdate())}
          >
            <SvgIcon
              className="refresh_svg_icon"
              component={RefreshButton}
              inheritViewBox
            />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={dialogOpen}
        dialogClassName="dialog"
        Dialog_Title={`${isEdit ? "Update" : "Add"} Exam Date`}
        dialogContentClassName="dialog_content"
        Dialog_Content={
          <ExamdateForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => {
                setDialogOpen(false);
                setIsEdit(false);
              }}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => formRef.current?.requestSubmit()}
            >
              Save
            </ButtonField>
          </>
        }
      />
      <ResponseDialog response={addExamdate} parentDialog={setDialogOpen} />
      <ResponseDialog response={EditExamdate} parentDialog={setDialogOpen} />
      <DeleteDialog
        deleteableName={deleteDialogData.name ?? ""}
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        deleteFunction={() => {
          dispatch(deleteExamdate(deleteDialogData.id));
        }}
        response={deleteExamdates}
      />
    </>
  );
};

export default Examdate;
